import React from "react";
import IndivisualExcelData from "./IndivisualExcelData";

function ExcelData({ excelData }) {
  return (
    <>
      {excelData?.map((row, index) => (
        <tr key={index}>
          <IndivisualExcelData row={row} />
        </tr>
      ))}
    </>
  );
}

export default ExcelData;
